/* eslint-disable react/no-direct-mutation-state */
import React, { Component } from "react";
import { connect } from "react-redux";
import {
	Button,
	Checkbox,
	Col,
	Form,
	Input,
	Modal,
	Radio,
	Row,
	Select,
	Slider,
	Typography,
	message,
	notification,
} from "antd";
import {
	ArrowRightOutlined,
	CloseOutlined,
	LoadingOutlined,
	UserOutlined,
} from "@ant-design/icons";
import { HiOutlineArrowSmallLeft } from "react-icons/hi2";
import dayjs from "dayjs";
import { removeStorageWhenLogout, setHtmlStorage } from "../../config/helper";
import config from "../../config/index";
import FetchApi from "../../services/api";
import * as actionAuth from "../../store/auth/action";
import * as actionProfile from "../../store/profile/action";
import iconBoth from "../../assets/img/icon-both.png";
import iconMale from "../../assets/img/icon-male.png";
import iconFemale from "../../assets/img/icon-female.png";
import "./setting.css";

class Settings extends Component {
	constructor(props) {
		super(props);
		const type = window.location.search === "";
		const update = window.location.search.replace("?type=", "");

		this.state = {
			type: type ? "create" : update,
			step: "name",
			name: null,
			nameValidation: {
				show: false,
				message: "",
			},
			pronouns: null,
			pronounsValidation: {
				show: false,
				message: "",
			},
			dobDay: "01",
			dobMonth: "Jan",
			dobYear: dayjs().subtract(18, "year").format("YYYY"),
			dobValidation: {
				show: false,
				message: "",
			},
			aIsrc: null,
			avatarImageValidation: {
				show: false,
				message: "",
			},
			aIname: null,
			avatarNameValidation: {
				show: false,
				message: "",
			},
			aIinterests: null,
			aItraits: [],
			avatarTraitsValidation: {
				show: false,
				message: "",
			},
			aIpersonality: null,
			aIpersonality1: 0,
			aIpersonality1Str: [],
			aIpersonality2: 0,
			aIpersonality2Str: [],
			aIpersonality3: 0,
			aIpersonality3Str: [],
			confirmModal: false,
		};
	}

	componentDidMount() {
		// setInterval(() => {
		//   this.authRefreshToken();
		// }, 30000);
	}

	authRefreshToken = async () => {
		const response = await FetchApi(
			`${config.urls.apiBaseUrl}api/Account/refreshToken`,
			"POST"
		);
		if (response.httpStatus === 200) {
			setHtmlStorage("accessToken", response.data.token);
		}
		if (response.httpStatus === 401) {
			removeStorageWhenLogout();
			window.location.href = "/signin";
		}
	};

	handleInputChange = (evt) => {
		const { name, value } = evt.target;
		this.setState({ [name]: value });
	};

	handleSliderChange = (value, name) => {
		this.setState({ [name]: value });
	};

	handlePersonalitySave = () => {
		let newPersonal = "";
		if (this.state.aIpersonality1 === -100) {
			this.state.aIpersonality1Str = ["Extremely Shy"];
		} else if (this.state.aIpersonality1 === -50) {
			this.state.aIpersonality1Str = ["Shy"];
		} else if (this.state.aIpersonality1 === 50) {
			this.state.aIpersonality1Str = ["Flirty"];
		} else if (this.state.aIpersonality1 === 100) {
			this.state.aIpersonality1Str = ["Extremely Flirty"];
		} else if (this.state.aIpersonality1 === 0) {
			this.state.aIpersonality1Str = ["Friendly"];
		}
		if (this.state.aIpersonality2 === -100) {
			this.state.aIpersonality2Str = ["Extremely Pessimistic"];
		} else if (this.state.aIpersonality2 === -50) {
			this.state.aIpersonality2Str = ["Pessimistic"];
		} else if (this.state.aIpersonality2 === 50) {
			this.state.aIpersonality2Str = ["Optimistic"];
		} else if (this.state.aIpersonality2 === 100) {
			this.state.aIpersonality2Str = ["Extremely Optimistic"];
		} else if (this.state.aIpersonality2 === 0) {
			this.state.aIpersonality2Str = ["Rational"];
		}
		if (this.state.aIpersonality3 === -100) {
			this.state.aIpersonality3Str = ["Extremely Open"];
		} else if (this.state.aIpersonality3 === -50) {
			this.state.aIpersonality3Str = ["Open"];
		} else if (this.state.aIpersonality3 === 50) {
			this.state.aIpersonality3Str = ["Mysterious"];
		} else if (this.state.aIpersonality3 === 100) {
			this.state.aIpersonality3Str = ["Extremely Mysterious"];
		} else if (this.state.aIpersonality3 === 0) {
			this.state.aIpersonality3Str = ["Ordinary"];
		}

		newPersonal = this.state.aIpersonality1Str.concat(
			this.state.aIpersonality2Str,
			this.state.aIpersonality3Str
		);
		newPersonal = newPersonal.join(" and ");
		this.setState({
			aIpersonality: newPersonal,
			step: "traits-buddy",
		});
	};

	handleCheckboxChange = (value) => {
		this.setState({ aItraits: value });
	};

	handleDateChange = (date) => {
		this.setState({ dob: date });
	};

	handleSaveSetting = async () => {
		const traits = this.state.aItraits.join(", ");

		let gender = "";
		if (this.state.pronouns === "He/Him") {
			gender = "male";
		}
		if (this.state.pronouns === "She/Her") {
			gender = "female";
		}
		if (this.state.pronouns === "They/Them") {
			gender = "other";
		}

		let newPersonal = "";
		let aIpersonality1Str = "";
		let aIpersonality2Str = "";
		let aIpersonality3Str = "";

		if (this.state.aIpersonality1 === -100) {
			aIpersonality1Str = ["Extremely Shy"];
		} else if (this.state.aIpersonality1 === -50) {
			aIpersonality1Str = ["Shy"];
		} else if (this.state.aIpersonality1 === 50) {
			aIpersonality1Str = ["Flirty"];
		} else if (this.state.aIpersonality1 === 100) {
			aIpersonality1Str = ["Extremely Flirty"];
		} else if (this.state.aIpersonality1 === 0) {
			aIpersonality1Str = ["Friendly"];
		}

		if (this.state.aIpersonality2 === -100) {
			aIpersonality2Str = ["Extremely Pessimistic"];
		} else if (this.state.aIpersonality2 === -50) {
			aIpersonality2Str = ["Pessimistic"];
		} else if (this.state.aIpersonality2 === 50) {
			aIpersonality2Str = ["Optimistic"];
		} else if (this.state.aIpersonality2 === 100) {
			aIpersonality2Str = ["Extremely Optimistic"];
		} else if (this.state.aIpersonality2 === 0) {
			aIpersonality2Str = ["Rational"];
		}

		if (this.state.aIpersonality3 === -100) {
			aIpersonality3Str = ["Extremely Open"];
		} else if (this.state.aIpersonality3 === -50) {
			aIpersonality3Str = ["Open"];
		} else if (this.state.aIpersonality3 === 50) {
			aIpersonality3Str = ["Mysterious"];
		} else if (this.state.aIpersonality3 === 100) {
			aIpersonality3Str = ["Extremely Mysterious"];
		} else if (this.state.aIpersonality3 === 0) {
			aIpersonality3Str = ["Ordinary"];
		}

		newPersonal = aIpersonality1Str.concat(
			aIpersonality2Str,
			aIpersonality3Str
		);

		newPersonal = newPersonal.join(" and ");

		const payloadProfile = {
			data: JSON.stringify({
				name: this.state.name,
				pronouns: this.state.pronouns,
				gender,
				dob: `${dayjs(
					`${this.state.dobDay}-${this.state.dobMonth}-${this.state.dobYear}`
				).format("YYYY-MM-DD")}T00:00:00Z`,
			}),
		};

		const payloadAvatar = {
			data: JSON.stringify({
				aIsrc: this.state.aIsrc,
				aIname: this.state.aIname,
				aIinterests: traits,
				aIpersonality: newPersonal,
			}),
		};

		this.setState({ step: "finish" });

		let response;
		if (this.state.type === "create") {
			await this.props.createProfile(payloadProfile);
			if (this.props.profileResponse.httpStatus === 401) {
				notification.error({ message: "Unauthorize." });
				removeStorageWhenLogout();
				setTimeout(() => {
					window.location.href = "/signin";
				}, 3000);
			}
			if (this.props.profileResponse.httpStatus === 200) {
				response = await FetchApi(
					`${config.urls.apiBaseUrl}api/Character/CreateCharacter`,
					"POST",
					payloadAvatar
				);
				if (response.httpStatus === 401) {
					notification.error({ message: "Unauthorize." });
					removeStorageWhenLogout();
					setTimeout(() => {
						window.location.href = "/signin";
					}, 3000);
				}
				if (response.httpStatus === 200) {
					this.handleSwapAvatar(response.data);
				} else {
					notification.error({
						message:
							"Something wrong, please try again in few minutes.",
					});
					this.setState({ step: "traits-buddy" });
				}
			} else {
				notification.error({
					message:
						"Something wrong, please try again in few minutes.",
				});
				this.setState({ step: "traits-buddy" });
			}
		}
	};

	handleSwapAvatar = async (data) => {
		const response = await FetchApi(
			`${config.urls.apiBaseUrl}api/Character/SwapCharacter/${data.id}`,
			"PUT"
		);
		if (response.httpStatus === 401) {
			notification.error({ message: "Unauthorize." });
			removeStorageWhenLogout();
			setTimeout(() => {
				window.location.href = "/signin";
			}, 3000);
		}
		if (response.httpStatus === 200) {
			setHtmlStorage("dataAvatar", JSON.stringify(data));
			this.setState({
				activeAvatar: data.id,
				activeAvatarMessage: "",
			});
			setTimeout(() => {
				window.location.href = "/";
			}, 3000);
		} else {
			notification.error({
				message: "Something wrong, please try again in few minutes.",
			});
		}
	};

	handleConfirmClose = () => {
		this.setState({ confirmModal: true });
	};

	handleCloseConfirm = () => {
		this.setState({ confirmModal: false });
	};

	handleConfirm = () => {
		this.setState({ confirmModal: false });
		window.location.href = "/";
	};

	disabledDate = (current) => {
		return current && current > dayjs().subtract(18, "years");
	};

	render() {
		const options = [
			{ label: "🍳 Cooking", value: "cooking" },
			{ label: "👠 Fashion", value: "fashion" },
			{ label: "🎤 Karaoke", value: "karaoke" },
			{ label: "🍷 Wine", value: "wine" },
			{ label: "🎲 Board Games", value: "board games" },
			{ label: "🏐️ Sports", value: "sports" },
			{ label: "🐕 Dogs", value: "dogs" },
			{ label: "☕ Coffee", value: "coffee" },
			{ label: "🤳️ Instagram", value: "instagram" },
			{ label: "💪 Working Out", value: "working Out" },
			{ label: "♊ Astrology", value: "astrology" },
			{ label: "📸 Photography", value: "photography" },
		];

		const dayOptions = Array.from({ length: 31 }, (item, i) => {
			if (i < 9) {
				return { value: `0${i + 1}`, label: `0${i + 1}` };
			} else {
				return { value: `${i + 1}`, label: `${i + 1}` };
			}
		});

		const monthOptions = Array.from({ length: 12 }, (item, i) => {
			return {
				value: new Date(0, i).toLocaleString("en-US", {
					month: "short",
				}),
				label: new Date(0, i).toLocaleString("en-US", {
					month: "short",
				}),
			};
		});

		const yearOptions = (startYear) => {
			const currentYear = dayjs().subtract(18, "years").format("YYYY");
			const years = [];
			startYear = startYear || 1900;
			for (let i = startYear; i <= currentYear; i++) {
				years.push({ value: `${i}`, label: `${i}` });
			}
			return years;
		};

		return (
			<div className="setting-screen">
				<div className="setting-wrapper">
					{this.state.step === "name" && (
						<>
							<div
								className="top-section"
								style={{
									display: "flex",
									justifyContent: "space-between",
								}}
							>
								<div>
									<Typography.Paragraph>
										Hello and welcome!
									</Typography.Paragraph>
									<Typography.Title level={4}>
										Let's get started
									</Typography.Title>
								</div>
								<div>
									<Button
										type="icon"
										icon={<CloseOutlined />}
										onClick={this.handleConfirmClose}
										style={{
											display: "inline-flex",
											justifyContent: "center",
											alignItems: "center",
											background: "transparent",
											border: "1px solid #ffffff",
											borderRadius: "100%",
											width: "40px",
											height: "40px",
											lineHeight: 1,
										}}
									/>
								</div>
							</div>
							<div className="bottom-section">
								<Form colon={false} layout="vertical">
									<Form.Item
										label="What do we call you?"
										hasFeedback={
											this.state.nameValidation.show
										}
										validateStatus={
											this.state.nameValidation.show
												? "error"
												: "success"
										}
										help={this.state.nameValidation.message}
									>
										<Input
											prefix={<UserOutlined />}
											name="name"
											value={this.state.name}
											onChange={this.handleInputChange}
										/>
									</Form.Item>
									<Button
										type="primary"
										htmlType="submit"
										onClick={() => {
											if (
												this.state.name === null ||
												this.state.name === ""
											) {
												this.setState({
													nameValidation: {
														show: true,
														message:
															"Please fill your name!",
													},
												});
												return;
											} else {
												this.setState({ step: "dob" });
											}
										}}
									>
										Continue <ArrowRightOutlined />
									</Button>
								</Form>
							</div>
						</>
					)}
					{this.state.step === "dob" && (
						<>
							<div
								className="top-section"
								style={{
									display: "flex",
									justifyContent: "space-between",
								}}
							>
								<div>
									<Typography.Paragraph>
										Hello and welcome!
									</Typography.Paragraph>
									<Typography.Title level={4}>
										Let's get started
									</Typography.Title>
								</div>
								<div>
									<Button
										type="icon"
										icon={<CloseOutlined />}
										onClick={this.handleConfirmClose}
										style={{
											display: "inline-flex",
											justifyContent: "center",
											alignItems: "center",
											background: "transparent",
											border: "1px solid #ffffff",
											borderRadius: "100%",
											width: "40px",
											height: "40px",
											lineHeight: 1,
										}}
									/>
								</div>
							</div>
							<div className="bottom-section">
								<Form colon={false} layout="vertical">
									<Form.Item
										label="When is your birthday?"
										hasFeedback={
											this.state.dobValidation.show
										}
										validateStatus={
											this.state.dobValidation.show
												? "error"
												: "success"
										}
										help={this.state.dobValidation.message}
									>
										<Row gutter={10}>
											<Col xs={8}>
												<Select
													showSearch
													suffixIcon={<></>}
													options={dayOptions}
													value={this.state.dobDay}
													onChange={(value) =>
														this.setState({
															dobDay: value,
														})
													}
												/>
											</Col>
											<Col xs={8}>
												<Select
													showSearch
													suffixIcon={<></>}
													options={monthOptions}
													value={this.state.dobMonth}
													onChange={(value) =>
														this.setState({
															dobMonth: value,
														})
													}
												/>
											</Col>
											<Col xs={8}>
												<Select
													showSearch
													suffixIcon={<></>}
													options={yearOptions(1900)}
													value={this.state.dobYear}
													onChange={(value) =>
														this.setState({
															dobYear: value,
														})
													}
												/>
											</Col>
										</Row>
									</Form.Item>
									<Button
										type="primary"
										htmlType="submit"
										onClick={() => {
											if (
												this.state.dob === null ||
												this.state.dob === ""
											) {
												this.setState({
													dobValidation: {
														show: true,
														message:
															"Please fill your date of birthday!",
													},
												});
												return;
											} else {
												this.setState({
													step: "pronouns",
												});
											}
										}}
									>
										Continue <ArrowRightOutlined />
									</Button>
								</Form>
							</div>
						</>
					)}
					{this.state.step === "pronouns" && (
						<>
							<div
								className="top-section"
								style={{
									display: "flex",
									justifyContent: "space-between",
								}}
							>
								<div>
									<Button
										type="text"
										className="btn-back"
										icon={
											<HiOutlineArrowSmallLeft
												style={{ fontSize: 24 }}
											/>
										}
										onClick={() =>
											this.setState({ step: "dob" })
										}
									/>
									<Typography.Title level={4}>
										What are your preferred pronouns?
									</Typography.Title>
								</div>
								<div>
									<Button
										type="icon"
										icon={<CloseOutlined />}
										onClick={this.handleConfirmClose}
										style={{
											display: "inline-flex",
											justifyContent: "center",
											alignItems: "center",
											background: "transparent",
											border: "1px solid #ffffff",
											borderRadius: "100%",
											width: "40px",
											height: "40px",
											lineHeight: 1,
										}}
									/>
								</div>
							</div>
							<div className="bottom-section">
								<Form.Item
									hasFeedback={
										this.state.pronounsValidation.show
									}
									validateStatus={
										this.state.pronounsValidation.show
											? "error"
											: "success"
									}
									help={this.state.pronounsValidation.message}
								>
									<Radio.Group
										name="pronouns"
										value={this.state.pronouns}
										onChange={this.handleInputChange}
									>
										<Radio value={"He/Him"}>
											<img
												src={iconMale}
												alt="Icon Gender"
											/>
											He/Him
										</Radio>
										<Radio value={"She/Her"}>
											<img
												src={iconFemale}
												alt="Icon Gender"
											/>
											She/Her
										</Radio>
										<Radio value={"They/Them"}>
											<img
												src={iconBoth}
												alt="Icon Gender"
											/>
											They/Them
										</Radio>
									</Radio.Group>
								</Form.Item>
								<Button
									type="primary"
									onClick={() => {
										if (
											this.state.pronouns === null ||
											this.state.pronouns === ""
										) {
											this.setState({
												pronounsValidation: {
													show: true,
													message:
														"Please choose your pronouns!",
												},
											});
											return;
										} else {
											this.setState({
												step: "avatar-buddy",
											});
										}
									}}
								>
									Continue <ArrowRightOutlined />
								</Button>
							</div>
						</>
					)}
					{this.state.step === "avatar-buddy" && (
						<>
							<div
								className="top-section"
								style={{
									display: "flex",
									justifyContent: "space-between",
								}}
							>
								<div>
									<Button
										type="text"
										className="btn-back"
										icon={
											<HiOutlineArrowSmallLeft
												style={{ fontSize: 24 }}
											/>
										}
										onClick={() =>
											this.setState({ step: "pronouns" })
										}
									/>
									<Typography.Title level={4}>
										How do you want your AI companion to
										look like?
									</Typography.Title>
								</div>
								<div>
									<Button
										type="icon"
										icon={<CloseOutlined />}
										onClick={this.handleConfirmClose}
										style={{
											display: "inline-flex",
											justifyContent: "center",
											alignItems: "center",
											background: "transparent",
											border: "1px solid #ffffff",
											borderRadius: "100%",
											width: "40px",
											height: "40px",
											lineHeight: 1,
										}}
									/>
								</div>
							</div>
							<div className="middle-section">
								<div className="avatar-buddy-wrapper">
									<img
										src={
											this.state.aIsrc !== null
												? this.state.aIsrc
												: `${config.urls.feBaseUrl}assets/img/no-avatar.png`
										}
										alt="Avatar"
									/>
								</div>
							</div>
							<div className="bottom-section">
								<Form.Item
									hasFeedback={
										this.state.avatarImageValidation.show
									}
									validateStatus={
										this.state.avatarImageValidation.show
											? "error"
											: "success"
									}
									help={
										this.state.avatarImageValidation.message
									}
								>
									<Radio.Group
										className="choose-avatar"
										name="aIsrc"
										value={this.state.aIsrc}
										onChange={this.handleInputChange}
									>
										<Radio
											value={`${config.urls.feBaseUrl}assets/img/man-1.png`}
										>
											<img
												src={`${config.urls.feBaseUrl}assets/img/man-1.png`}
												alt="Avatar Buddy"
											/>
										</Radio>
										<Radio
											value={`${config.urls.feBaseUrl}assets/img/man-2.png`}
										>
											<img
												src={`${config.urls.feBaseUrl}assets/img/man-2.png`}
												alt="Avatar Buddy"
											/>
										</Radio>
										<Radio
											value={`${config.urls.feBaseUrl}assets/img/woman-1.png`}
										>
											<img
												src={`${config.urls.feBaseUrl}assets/img/woman-1.png`}
												alt="Avatar Buddy"
											/>
										</Radio>
										<Radio
											value={`${config.urls.feBaseUrl}assets/img/woman-2.png`}
										>
											<img
												src={`${config.urls.feBaseUrl}assets/img/woman-2.png`}
												alt="Avatar Buddy"
											/>
										</Radio>
										<Radio
											value={`${config.urls.feBaseUrl}assets/img/woman-3.png`}
										>
											<img
												src={`${config.urls.feBaseUrl}assets/img/woman-3.png`}
												alt="Avatar Buddy"
											/>
										</Radio>
									</Radio.Group>
								</Form.Item>
								<Button
									type="primary"
									onClick={() => {
										if (
											this.state.aIsrc === null ||
											this.state.aIsrc === ""
										) {
											this.setState({
												avatarImageValidation: {
													show: true,
													message:
														"Please choose your avatar buddy!",
												},
											});
											return;
										} else {
											this.setState({
												step: "name-buddy",
											});
										}
									}}
								>
									Continue <ArrowRightOutlined />
								</Button>
							</div>
						</>
					)}
					{this.state.step === "name-buddy" && (
						<>
							<div
								className="top-section"
								style={{
									display: "flex",
									justifyContent: "space-between",
								}}
							>
								<div>
									<Button
										type="text"
										className="btn-back"
										icon={
											<HiOutlineArrowSmallLeft
												style={{ fontSize: 24 }}
											/>
										}
										onClick={() =>
											this.setState({
												step: "avatar-buddy",
											})
										}
									/>
									<Typography.Title level={4}>
										What would you like to call your AI
										companion?
									</Typography.Title>
								</div>
								<div>
									<Button
										type="icon"
										icon={<CloseOutlined />}
										onClick={this.handleConfirmClose}
										style={{
											display: "inline-flex",
											justifyContent: "center",
											alignItems: "center",
											background: "transparent",
											border: "1px solid #ffffff",
											borderRadius: "100%",
											width: "40px",
											height: "40px",
											lineHeight: 1,
										}}
									/>
								</div>
							</div>
							<div className="middle-section">
								<div className="avatar-buddy-wrapper">
									<img
										src={
											this.state.aIsrc !== null
												? this.state.aIsrc
												: `${config.urls.feBaseUrl}assets/img/no-avatar.png`
										}
										alt="Avatar"
									/>
									<div className="buddy-name">
										{this.state.aIname !== null
											? this.state.aIname
											: "Name"}
									</div>
								</div>
							</div>
							<div className="bottom-section">
								<Form colon={false} layout="vertical">
									<Form.Item
										hasFeedback={
											this.state.avatarNameValidation.show
										}
										validateStatus={
											this.state.avatarNameValidation.show
												? "error"
												: "success"
										}
										help={
											this.state.avatarNameValidation
												.message
										}
									>
										<Input
											placeholder="Enter their name"
											prefix={<UserOutlined />}
											name="aIname"
											value={this.state.aIname}
											onChange={this.handleInputChange}
										/>
									</Form.Item>
									<Button
										type="primary"
										htmlType="submit"
										onClick={() => {
											if (
												this.state.aIname === null ||
												this.state.aIname === ""
											) {
												this.setState({
													avatarNameValidation: {
														show: true,
														message:
															"Please fill your avatar buddy name!",
													},
												});
												return;
											} else {
												this.setState({
													step: "personal-buddy",
												});
											}
										}}
									>
										Continue <ArrowRightOutlined />
									</Button>
								</Form>
							</div>
						</>
					)}
					{this.state.step === "personal-buddy" && (
						<>
							<div
								className="top-section"
								style={{
									display: "flex",
									justifyContent: "space-between",
								}}
							>
								<div>
									<Button
										type="text"
										className="btn-back"
										icon={
											<HiOutlineArrowSmallLeft
												style={{ fontSize: 24 }}
											/>
										}
										onClick={() =>
											this.setState({
												step: "name-buddy",
											})
										}
									/>
									<Typography.Title level={4}>
										Tweak their personality
									</Typography.Title>
								</div>
								<div>
									<Button
										type="icon"
										icon={<CloseOutlined />}
										onClick={this.handleConfirmClose}
										style={{
											display: "inline-flex",
											justifyContent: "center",
											alignItems: "center",
											background: "transparent",
											border: "1px solid #ffffff",
											borderRadius: "100%",
											width: "40px",
											height: "40px",
											lineHeight: 1,
										}}
									/>
								</div>
							</div>
							<div className="middle-section">
								<div className="avatar-buddy-wrapper">
									<img
										src={
											this.state.aIsrc !== null
												? this.state.aIsrc
												: `${config.urls.feBaseUrl}assets/img/no-avatar.png`
										}
										alt="Avatar"
									/>
									<div className="buddy-name">
										{this.state.aIname !== null
											? this.state.aIname
											: "Name"}
									</div>
								</div>
							</div>
							<div className="bottom-section">
								<div className="slider-wrapper">
									<Slider
										min={-100}
										max={100}
										defaultValue={0}
										step={50}
										marks={{
											"-100": "Extremely Shy",
											// "-50": "Shy",
											0: "Friendly",
											// 50: "Flirty",
											100: "Extremely Flirty",
										}}
										value={this.state.aIpersonality1}
										onChange={(val) =>
											this.handleSliderChange(
												val,
												"aIpersonality1"
											)
										}
									/>
									<Slider
										min={-100}
										max={100}
										defaultValue={0}
										step={50}
										marks={{
											"-100": "Extremely Pessimistic",
											// "-50": "Pessimistic",
											0: "Rational",
											// 50: "Optimistic",
											100: "Extremely Optimistic",
										}}
										value={this.state.aIpersonality2}
										onChange={(val) =>
											this.handleSliderChange(
												val,
												"aIpersonality2"
											)
										}
									/>
									<Slider
										min={-100}
										max={100}
										defaultValue={0}
										step={50}
										marks={{
											"-100": "Extremely Open",
											// "-50": "Open",
											0: "Ordinary",
											// 50: "Mysterious",
											100: "Extremely Mysterious",
										}}
										value={this.state.aIpersonality3}
										onChange={(val) =>
											this.handleSliderChange(
												val,
												"aIpersonality3"
											)
										}
									/>
								</div>
								<Button
									type="primary"
									onClick={() => this.handlePersonalitySave()}
								>
									Continue <ArrowRightOutlined />
								</Button>
							</div>
						</>
					)}
					{this.state.step === "traits-buddy" && (
						<>
							<div
								className="top-section"
								style={{
									display: "flex",
									justifyContent: "space-between",
								}}
							>
								<div>
									<Button
										type="text"
										className="btn-back"
										icon={
											<HiOutlineArrowSmallLeft
												style={{ fontSize: 24 }}
											/>
										}
										onClick={() =>
											this.setState({
												step: "personal-buddy",
											})
										}
									/>
									<Typography.Title level={4}>
										Choose some interests
									</Typography.Title>
								</div>
								<div>
									<Button
										type="icon"
										icon={<CloseOutlined />}
										onClick={this.handleConfirmClose}
										style={{
											display: "inline-flex",
											justifyContent: "center",
											alignItems: "center",
											background: "transparent",
											border: "1px solid #ffffff",
											borderRadius: "100%",
											width: "40px",
											height: "40px",
											lineHeight: 1,
										}}
									/>
								</div>
							</div>
							<div className="middle-section">
								<div className="avatar-buddy-wrapper">
									<img
										src={
											this.state.aIsrc !== null
												? this.state.aIsrc
												: `${config.urls.feBaseUrl}assets/img/no-avatar.png`
										}
										alt="Avatar"
									/>
									<div className="buddy-name">
										{this.state.aIname !== null
											? this.state.aIname
											: "Name"}
									</div>
								</div>
							</div>
							<div className="bottom-section">
								<Form.Item
									hasFeedback={
										this.state.avatarTraitsValidation.show
									}
									validateStatus={
										this.state.avatarTraitsValidation.show
											? "error"
											: "success"
									}
									help={
										this.state.avatarTraitsValidation
											.message
									}
								>
									<Checkbox.Group
										options={options}
										name="aItraits"
										value={this.state.aItraits}
										onChange={this.handleCheckboxChange}
									/>
								</Form.Item>
								<Button
									type="primary"
									onClick={() => {
										if (this.state.aItraits.length === 0) {
											this.setState({
												avatarTraitsValidation: {
													show: true,
													message:
														"Please choose your avatar buddy traits!",
												},
											});
											return;
										} else {
											this.handleSaveSetting();
										}
									}}
								>
									Continue <ArrowRightOutlined />
								</Button>
							</div>
						</>
					)}
					{this.state.step === "finish" && (
						<div className="setting-final-step">
							<div className="top-section">
								<Typography.Title level={4}>
									Yay, let's set them up!
								</Typography.Title>
							</div>
							<div className="middle-section">
								<div className="avatar-buddy-wrapper">
									<img
										src={
											this.state.aIsrc !== null
												? this.state.aIsrc
												: `${config.urls.feBaseUrl}assets/img/no-avatar.png`
										}
										alt="Avatar"
									/>
									<div className="buddy-name">
										{this.state.aIname !== null
											? this.state.aIname
											: "Name"}
									</div>
								</div>
							</div>
							<div className="bottom-section">
								<LoadingOutlined />
							</div>
						</div>
					)}
				</div>
				<Modal
					open={this.state.confirmModal}
					onOk={this.handleConfirm}
					onCancel={this.handleCloseConfirm}
				>
					Are you sure want to exit and discard the change?
				</Modal>
			</div>
		);
	}
}

const stateToProps = (state) => {
	const { auth, profile } = state;
	return {
		refreshResponse: auth.refreshResponse,
		profileLoading: profile.loading,
		profileData: profile.profile,
		profileResponse: profile.profileResponse,
	};
};

const dispatchToProps = (dispatch) => ({
	authRefresh: () => dispatch(actionAuth.authRefresh()),
	getProfile: () => dispatch(actionProfile.getProfile()),
	createProfile: (payload) => dispatch(actionProfile.createProfile(payload)),
	updateProfile: (payload) => dispatch(actionProfile.updateProfile(payload)),
});

export default connect(stateToProps, dispatchToProps)(Settings);
